module.exports = __webpack_public_path__ + "static/media/icon_no_notification.f1dc435d.svg";